import {IntermediatePart} from "../../intermediatePart";
import {PLACEMENTS} from "../../constants";
import Cabinet from "../../parts/cabinet";

export default class Range extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'range';
    this.partName = 'Range';
    this.translateId = "visualizer.kitchen.appliance.range";
  }

  load(dbFeature) {
    if (dbFeature.metaData && dbFeature.metaData["Placement"]
      && !dbFeature.metaData["Placement"].includes(PLACEMENTS.Countertop)) {
      return false
    }
    return super.load_(dbFeature, new Range());
  }

  setLayers(layout) {

    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    if (cabinetParent && cabinetParent.bottomCabinet && cabinetParent.bottomCabinet.activeFeature
      && cabinetParent.bottomCabinet.activeFeature.metaData["Appliance"]
      && cabinetParent.bottomCabinet.activeFeature.metaData["Appliance"].includes("None")) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  getArrayOfConditions() {
    return []
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Appliances.Range;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
